import { z } from "zod";

export const cancelVeredictSchema = z.object({
  veredict: z.enum(["APPROVE", "REJECT"], {
    message: "El veredicto es obligatorio",
  }),
  cancellationReason: z
    .string()
    .min(1, "El motivo de cancelación es obligatorio")
    .max(2000, "El motivo no puede exceder los 2000 caracteres")
    .refine((val) => {
      return val.trim().length > 0;
    }, "El motivo de cancelación no puede estar vacío"),
  confirmationChecked: z
    .boolean()
    .refine(
      (val) => val === true,
      "Debes confirmar que deseas cancelar la solicitud",
    ),
});

export type CancelVeredictFormData = z.infer<typeof cancelVeredictSchema>;
